import { useInlineStatusQuery } from "@octopusdeploy/octopus-react-client";
import { useEffect } from "react";
import { client } from "~/clientInstance";
import type { ProjectStatusAction } from "./actions";
import { projectStatusActions } from "./actions";
import type { ProjectStatusState } from "./reducer";
export type ProjectStatus = {
    state: ProjectStatusState;
    dispatch: React.Dispatch<ProjectStatusAction>;
};
const useProjectStatusFromServer = (dispatch: React.Dispatch<ProjectStatusAction>, spaceId: string, projectSlug?: string) => {
    const { result: projectStatusFromServer, refetch: refetchProjectStatusFromServer } = useInlineStatusQuery(async (repository) => {
        if (!projectSlug) {
            dispatch({ type: projectStatusActions.statusRequestedBeforeProjectExists });
            return undefined;
        }
        const serverState = await repository.Projects.getProjectStatus(projectSlug, spaceId);
        dispatch({
            type: projectStatusActions.serverStateLoaded,
            serverState,
        });
        return serverState;
    }, [projectSlug, spaceId, dispatch], "Load project status");
    return { projectStatusFromServer, refetchProjectStatusFromServer };
};
export function useProjectStatus(dispatch: React.Dispatch<ProjectStatusAction>, spaceId: string, projectSlug?: string, dismissed?: boolean): void {
    const shouldFetch = !!spaceId && !!projectSlug && !dismissed;
    const { refetchProjectStatusFromServer } = useProjectStatusFromServer(dispatch, spaceId, projectSlug);
    useEffect(() => {
        if (!shouldFetch)
            return;
        return client.subscribe((event) => {
            if (event.type === "EnvironmentCreated" || event.type === "DeploymentProcessModified" || event.type === "RunbookProcessModified" || event.type === "ReleaseProgressionModified" || event.type === "ProjectModified") {
                refetchProjectStatusFromServer();
            }
        });
    }, [shouldFetch, projectSlug, spaceId, refetchProjectStatusFromServer]);
}
